import { KeyedWord } from '../../main/types/asset/word.types.ts';

export const mapWordToRefText = (word: KeyedWord): string => {
  const usablePronunciation = word.pronunciations.filter((pronunciation) => !pronunciation.startsWith('<phoneme'));
  if (usablePronunciation.length === 0) {
    return '';
  }
  return usablePronunciation[0];
};
